import { gql } from '@apollo/client';

export const GET_CONVERSATIONS = gql`
  query GetConversations {
    conversations {
      id
      title
      updatedAt
      isCompleted
      lastMessage {
        id
        content
        sender
        type
        createdAt
        status
        toolCalls {
          id
          state
          approvalId
        }
      }
    }
  }
`;

export const CONVERSATION_UPDATED = gql`
  subscription ConversationUpdated {
    conversationUpdated {
      id
      title
    }
  }
`;
